import { Guid } from 'guid-typescript';
import { ItiBaseDto } from '@/iti-core-vue';
import { CategorySecondLevel } from './category-second-level';

export class CategoryFirstLevel extends ItiBaseDto {
    public code !: string;
    public description !: string;
    public categoriesSecondLevel !: CategorySecondLevel[]
    public externalID!: Guid;
}